<template>
  <div id="numbersQuadrant">
    <div class="row">
      <div class="col-md-6 pr-1">
        <div class="card mt-2 zone-card">
          <p class="text-center"><strong>Year One No VRM</strong></p>
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrOneCropEstTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">tons/acre</span>
            <span class="figure-label">Year One Total Crop Estimation</span>
          </div><!-- /.figure -->
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrOneJssTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">%</span>
            <span class="figure-label">Year One Juice Soluble Solids</span>
          </div><!-- /.figure -->
          <div class="figure">
            <span class="figure-unit">$</span>
            <animated-number :class="'figure-number'" :value="calcYrOnePpaTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-label">Year One Payment Per Acre <i v-b-tooltip.hover="'Pricing is an approximation based on historical data from National Grape for Concord grapes. Brix payments and penalties vary by processor. When a significant percentage of production falls under 15.0 brix there is a real risk that it will undermine the ability to market grapes.'" class="far fa-question-circle clickable"></i></span>
          </div><!-- /.figure -->
        </div><!-- /.card -->
      </div><!-- /.col-md-6 -->
      <div class="col-md-6 pl-1">
        <div class="card mt-2 zone-card">
          <p class="text-center"><strong>Year One With VRM</strong></p>
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrOneTrgCropVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">tons/acre</span>
            <span class="figure-label">Year One Target Crop with VRM</span>
          </div><!-- /.figure -->
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrOneJssVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">%</span>
            <span class="figure-label">Year One Juice Soluble Solids with VRM</span>
          </div><!-- /.figure -->
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrOneCropVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">tons/acre</span>
            <span class="figure-label">Year One Crop with VRM</span>
          </div><!-- /.figure -->
          <div class="figure">
            <span class="figure-unit">$</span>
            <animated-number :class="'figure-number'" :value="calcYrOnePpaVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-label">Year One Payment Per Acre with VRM <i v-b-tooltip.hover="'Pricing is an approximation based on historical data from National Grape for Concord grapes. Brix payments and penalties vary by processor. When a significant percentage of production falls under 15.0 brix there is a real risk that it will undermine the ability to market grapes.'" class="far fa-question-circle clickable"></i></span>
          </div><!-- /.figure -->
        </div><!-- /.card -->
      </div><!-- /.col-md-6 -->
    </div><!-- /.row -->
    <div class="row">
      <div class="col-md-6 pr-1">
        <div class="card mt-2 zone-card">
          <p class="text-center"><strong>Year Two No VRM</strong></p>
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrTwoCropPotChgTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">tons/acre</span>
            <span class="figure-label">Year Two Crop Potential Change</span>
          </div><!-- /.figure -->
          <div class="figure">
            <span class="figure-unit">$</span>
            <animated-number :class="'figure-number'" :value="calcYrTwoPpaPotChgTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-label">Year Two Payment Per Acre Potential Change</span>
          </div><!-- /.figure -->
        </div><!-- /.card -->
      </div><!-- /.col-md-6 -->
      <div class="col-md-6 pl-1">
        <div class="card mt-2 zone-card">
          <p class="text-center"><strong>Year Two With VRM</strong></p>
          <div class="figure">
            <animated-number :class="'figure-number'" :value="calcYrTwoCropPotChgVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-unit">tons/acre</span>
            <span class="figure-label">Year Two Crop Potential Change with VRM</span>
          </div><!-- /.figure -->
          <div class="figure">
            <span class="figure-unit">$</span>
            <animated-number :class="'figure-number'" :value="calcYrTwoPpaPotChgVrmTotal" :formatValue="formatRoundTwoPlaces" :duration="300" />
            <span class="figure-label">Year Two Payment Per Acre Potential Change with VRM</span>
          </div><!-- /.figure -->
        </div><!-- /.card -->
      </div><!-- /.col-md-6 -->
    </div><!-- /.row -->
  </div><!-- /#numbersQuadrant -->
</template>

<script>
import AnimatedNumber from 'animated-number-vue'
import { mapState } from 'vuex'
import { mapGetters } from 'vuex'

export default {
  components: { AnimatedNumber },
  computed: {
    ...mapState(['mzs', 'vpa']),
    ...mapGetters([
      'calcAreaPctTotal',
      'calcYrOneCropEstTotal',
      'calcYrOneJssTotal',
      'calcYrOnePpaTotal',
      'calcYrOneTrgCropVrmTotal',
      'calcYrTwoCropPotChgTotal',
      'calcYrTwoPpaPotChgTotal',
      'calcYrOneJssVrmTotal',
      'calcYrOneCropVrmTotal',
      'calcYrTwoCropPotChgVrmTotal',
      'calcYrOnePpaVrmTotal',
      'calcYrTwoPpaPotChgVrmTotal'
    ])
  },
  methods: {
    formatRoundTwoPlaces(value) {
      return value.toFixed(2);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/visualizations/NumbersQuadrant.vue